import type * as React from 'react';
import splitLines from 'split-lines';

import { groupTokensByLine, tokenizeCode } from './tokenizeCode';

/**
 * Tokenize plain code and highlight it with the right styles.
 */
export function highlightPlainCode(
    text: string,
    grammar: string,
    styles: Record<string, React.CSSProperties>
): React.ReactNode[][] {
    const lines = splitLines(text);
    const tokens = tokenizeCode(lines, grammar, {
        getLineContent(line) {
            return line;
        },
        createToken(args) {
            return args;
        },
    });

    return groupTokensByLine(tokens).map((lineTokens) => {
        return lineTokens.map((token) => {
            // `styles` are actually react-native-web styles but can be applied as inline styles
            // as they only contain the `color` and `backgroundColor` properties.
            const style = {};
            for (const className of token.classes.split(' ')) {
                Object.assign(style, styles[className]);
            }

            return (
                <span key={token.start} className="select-text" style={style}>
                    {token.raw || '\u200B'}
                </span>
            );
        });
    });
}
